import { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import SpinnerButton from '@/components/common/SpinnerButton';
import { useCoachActivities } from '@/data/coachActivity';
import { useApproveCoachActivityTenant } from '@/data/coachActivityTenant';

const ApproveDialog = () => {
  const [open, setIsOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const params = useParams();
  const coachActivities = useCoachActivities(params.id);
  const approveCoachActivityTenant = useApproveCoachActivityTenant();

  const coachActivity = coachActivities.data.find(
    (activity) => activity.id === params.coachActivityId
  );

  const handleApprove = async () => {
    setSubmitting(true);
    try {
      await approveCoachActivityTenant(
        coachActivity.coachActivityTenants[0].id
      );
      await coachActivities.mutate();
      setSubmitting(false);
      setIsOpen(false);
    } catch (error) {
      console.error('Error approving coach activity:', error);
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button>Approve</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Approve Coach Activity</DialogTitle>
          <DialogDescription>
            You are approving this coach to coach the activity &quot;
            {coachActivity?.activity.title}&quot; at all of your locations that
            support this activity.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <SpinnerButton loading={submitting} onClick={handleApprove}>
            Approve
          </SpinnerButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ApproveDialog;
